import { css } from "styled-components";
import colors from "../../tokens/colors";

export const likesAndCommentsVariables = css`
  --likes-n-comments-color: var(--theme-color-primary);
  --likes-n-comments-color-hover: ${colors.primary.cardanoBlue};
`;
